export default function (imgs) {
  if (typeof imgs === 'string') imgs = [imgs]
  return Promise.all(imgs.map(item => {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.src = item
      img.onload = () => resolve(item)
      img.onerror = () => reject(item)
    })
  }))
}
